import React from 'react';
import { Accordion, Grid } from 'semantic-ui-react';
import SimpleAccordion from '@/components/accordion/SimpleAccordion';
import RequestName from '../containers/RequestName';
import RequestStatus from '../containers/RequestStatus';
import RequestOutcomeList from './RequestOutcomeList';
import RequestSummaryList from './RequestSummaryList';
import RequestFieldList from '../forms/components/RequestFieldList';
import RequestUnknownFields from '../forms/components/RequestUnknownFields';
import RequestDestinationAccordion from './RequestDestinationAccordion';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import { approvalStatus, approvedOrDenied } from '../constants';

const RequestPanelNarrowContent = ({ category, code }) => {
  const state = Selectors.useRequestPanelContent({ category, code });
  const updatePanels = Events.useUpdateRequestPanels(category, { code });

  return (
    <>
      <Grid>
        <Grid.Row>
          <Grid.Column width={10}>
            <RequestName code={code} category={category} />
          </Grid.Column>
          <Grid.Column width={6} textAlign="right">
            <RequestStatus code={code} category={category} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Accordion styled>
        {Object.values(approvedOrDenied).includes(state.status) && (
        <SimpleAccordion
          active={state.panels.single.includes(0)}
          headerId={state.status === approvalStatus.APPROVE ? 'request.approval.title' : 'request.denied.title'}
          index={0}
          onClick={() => updatePanels({ index: 0, panel: 'single' })}
        >
          <RequestOutcomeList code={code} category={category} />
        </SimpleAccordion>
        )}
        <SimpleAccordion
          active={state.panels.single.includes(1)}
          headerId="request.summary.title"
          index={1}
          onClick={() => updatePanels({ index: 1, panel: 'single' })}
        >
          <RequestSummaryList code={code} category={category} withLinks />
        </SimpleAccordion>
        <RequestDestinationAccordion
          active={state.panels.single.includes(2)}
          category={category}
          code={code}
          index={2}
          onClick={() => updatePanels({ index: 2, panel: 'single' })}
        />
        <SimpleAccordion
          active={state.panels.single.includes(3)}
          headerText={state.sections?.project.label}
          index={2}
          onClick={() => updatePanels({ index: 3, panel: 'single' })}
        >
          <RequestFieldList code={code} category={category} section="project" />
        </SimpleAccordion>
        <SimpleAccordion
          active={state.panels.single.includes(4)}
          headerText={state.sections?.about.label}
          index={3}
          onClick={() => updatePanels({ index: 4, panel: 'single' })}
        >
          <RequestFieldList code={code} category={category} section="about" />
        </SimpleAccordion>
        <RequestUnknownFields
          active={state.panels.single.includes(5)}
          code={code}
          category={category}
          index={4}
          onClick={() => updatePanels({ index: 5, panel: 'single' })}
        />
      </Accordion>
    </>
  );
};

export default RequestPanelNarrowContent;
